var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcAgent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.165,
    height: 50.176,
    viewBox: "0 0 64.165 50.176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "user_1_",
    "data-name": "user (1)",
    d: "M46.2,31.851A23.5,23.5,0,0,0,40.2,28.1a1.96,1.96,0,0,0-1.592,3.582,19.6,19.6,0,0,1,5,3.115,7.816,7.816,0,0,1,2.648,5.874V44.3a1.962,1.962,0,0,1-1.96,1.96H5.88A1.962,1.962,0,0,1,3.92,44.3V40.67A7.816,7.816,0,0,1,6.568,34.8c1.98-1.74,7.75-5.788,18.52-5.788A14.521,14.521,0,1,0,16.254,26,27.248,27.248,0,0,0,3.98,31.851,11.736,11.736,0,0,0,0,40.67V44.3a5.886,5.886,0,0,0,5.88,5.88H44.3a5.886,5.886,0,0,0,5.88-5.88V40.67a11.736,11.736,0,0,0-3.98-8.819ZM14.5,14.5A10.584,10.584,0,1,1,25.088,25.088,10.6,10.6,0,0,1,14.5,14.5Zm0,0",
    transform: "translate(0 0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1861",
    "data-name": "Group 1861",
    transform: "translate(-1225.954 -463.855)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_186",
    "data-name": "Line 186",
    x2: 16.887,
    transform: "translate(1271.232 479.31)",
    fill: "#000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_187",
    "data-name": "Line 187",
    x2: 16.887,
    transform: "translate(1279.676 470.866) rotate(90)",
    fill: "#000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAgent);
export default __webpack_public_path__ + "static/media/ic_agent.ef4b22da4626b799a4b1066d0cf2e576.svg";
export { ForwardRef as ReactComponent };